import 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ColorPicker } from 'wix-rich-content-plugin-commons';
import { SelectionListItem, SelectionList, SettingsSeparator, SliderWithInput } from 'wix-rich-content-ui-components';
import { B as BACKGROUND_TYPES, a as BACKGROUND_PRESETS, t as toBackgroundString } from '../../../defaults-0542c304.js';
import { POLLS_DESIGN_BACKGROUND } from '../../../dataHooks.js';
import { s as styleInject } from '../../../style-inject.es-746bb8ed.js';
import { ColorIcon } from '../../../assets/icons/ColorIcon.js';
import { GradientIcon } from '../../../assets/icons/GradientIcon.js';
import { ImageIcon } from '../../../assets/icons/ImageIcon.js';
import 'wix-rich-content-common/libs/imageUtils';

var css_248z = "[dir=ltr] .mMqRs{text-align:left}[dir=rtl] .mMqRs{text-align:right}[dir] .LJMr1{border-bottom:1px solid #ededed;padding:0 20px}.LJMr1 .WoFk4{font-size:20px;line-height:1.4}[dir] .LJMr1 .WoFk4{margin:25px 0 20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.LJMr1{align-items:center;display:flex;flex-direction:row;justify-content:space-between}[dir] .LJMr1{padding:20px}}}@container (width < 640px){.LJMr1{align-items:center;display:flex;flex-direction:row;justify-content:space-between}[dir] .LJMr1{padding:20px}}.MjPDW{height:auto;overflow:hidden}.MjPDW,.eHalD{align-items:center;display:flex}.eHalD{flex-direction:row;font-family:inherit;font-size:16px;line-height:1;outline:none}[dir] .eHalD{background:none;border:0;padding:0}.eHalD.Ofofk{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}.eHalD.Mo0ez{color:inherit}.vxiFb{box-sizing:border-box;height:calc(100% - 227px);overflow:scroll;position:absolute;top:127px;width:100%}[dir] .vxiFb{padding:24px}.vxiFb *,.vxiFb :after,.vxiFb :before{box-sizing:inherit}.vxiFb input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.vxiFb{height:calc(100% - 100px);top:100px}[dir] .vxiFb{padding:20px}}}@container (width < 640px){.vxiFb{height:calc(100% - 100px);top:100px}[dir] .vxiFb{padding:20px}}.WoFk4{color:var(--ricos-settings-text-color,#000);font-size:16px;line-height:1.5}[dir] .WoFk4{margin:0 0 15px}.YeV7V{color:var(--ricos-settings-text-color,#000);font-size:14px;line-height:1.43}[dir] .YeV7V{margin:0 0 5px}._5p11N,.sRLyL,.ybgti{font-size:14px;line-height:1.43}[dir] ._5p11N,[dir] .sRLyL,[dir] .ybgti{margin:0 0 5px}[dir] .sRLyL{margin:10px 0}.CVL68{grid-column-gap:10px;grid-template-columns:repeat(3,1fr)}[dir] .CVL68{margin:10px 0}.zCHZF{grid-column-gap:10px;grid-auto-rows:1fr;grid-template-columns:repeat(4,1fr)}[dir] .zCHZF{margin:20px 0}@supports not (contain:inline-size){@media only screen and (max-width:640px){.zCHZF{grid-template-columns:repeat(3,1fr)}}}@container (width < 640px){.zCHZF{grid-template-columns:repeat(3,1fr)}}.Ozshx{align-items:center;display:flex;flex-direction:row;gap:5px}[dir] .Ozshx{margin:5px 0}.Ozshx._0Fg2L{align-items:start;display:flex;flex-direction:column}[dir] .Ozshx._0Fg2L{margin:10px 0 20px}.Df3tb{align-items:center;box-sizing:border-box;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;height:auto}[dir] .Df3tb{margin:0;padding-top:10px}[dir] .LOl36{margin:5px 0}[dir] .Df3tb:hover:not(.uG1wc){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}[dir] .uG1wc{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.uG1wc *{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .HYNdR{cursor:pointer;margin:15px 0;padding:0}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .HYNdR{padding-top:0!important}}}@container (width < 640px){[dir] .HYNdR{padding-top:0!important}}.z-N0-{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;justify-content:center;width:80%}[dir] .z-N0-{background:transparent}.yzvpO{align-items:center;bottom:0;display:flex;flex-direction:column;justify-content:center;position:fixed;top:0;z-index:8}[dir] .yzvpO{background-color:rgba(0,0,0,.6);cursor:auto}[dir=ltr] .yzvpO,[dir=rtl] .yzvpO{left:0;right:0}.QMoBk{display:flex;justify-content:flex-end;width:100%}[dir=ltr] .QMoBk{border-right:1px solid #ededed;padding-right:15px}[dir=rtl] .QMoBk{border-left:1px solid #ededed;padding-left:15px}.hQxTi{max-width:420px;position:absolute;top:77px;width:100%;z-index:2}[dir] .hQxTi{background-color:#fff}@supports not (contain:inline-size){@media only screen and (max-width:640px){.hQxTi{max-width:100%;top:50px}}}@container (width < 640px){.hQxTi{max-width:100%;top:50px}}._8reOo{display:flex;gap:12px;overflow-x:scroll}._8reOo::-webkit-scrollbar{width:0}[dir] ._8reOo::-webkit-scrollbar{background:transparent}._8reOo button{height:36px!important;width:36px!important}[dir] ._8reOo button{cursor:pointer}._8reOo button:after{height:36px!important;width:36px!important}.BxSGt{display:block;height:28px}";
var styles = {"settings_container":"mMqRs","header":"LJMr1","title":"WoFk4","header_button_list":"MjPDW","poll_header_button":"eHalD","poll_header_button_primary":"Ofofk","poll_header_button_secondary":"Mo0ez","section":"vxiFb","subtitle":"YeV7V","sliderWithInput_label":"sRLyL","label":"_5p11N","checkbox_label":"ybgti","preset_selector":"CVL68","layout_selector":"zCHZF","radioGroup":"Ozshx","radioPanel":"_0Fg2L","selectionListOption":"Df3tb","selectionListOptionLabel":"LOl36","selectionListOption_selected":"uG1wc","labeled_toggle_root":"HYNdR","modal":"z-N0-","overlay":"yzvpO","preview_button":"QMoBk","poll_tab_headers":"hQxTi","colorPicker_palette":"_8reOo","pollsSettings_spacer":"BxSGt"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var _a, _b;
const _DesignSettingsSection = class extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      backgroundType: ((_b = (_a = this.props.componentData.design.poll) == null ? void 0 : _a.background) == null ? void 0 : _b.type) || BACKGROUND_TYPES.COLOR
    });
    __publicField(this, "handleBackgroundChange", (value) => {
      const { backgroundType } = this.state;
      const {
        componentData: { design }
      } = this.props;
      let bgValue = { color: value };
      if (backgroundType === BACKGROUND_TYPES.GRADIENT) {
        bgValue = { gradient: JSON.parse(value) };
      }
      if (backgroundType === BACKGROUND_TYPES.IMAGE) {
        bgValue = { image: { src: { url: value } } };
      }
      this.updateDesign({
        poll: __spreadProps(__spreadValues({}, design.poll), { background: __spreadProps(__spreadValues({}, bgValue), { type: backgroundType }) })
      });
    });
    __publicField(this, "handleBackgroundColorChange", ({ color }) => {
      this.handleBackgroundChange(color);
    });
    __publicField(this, "handlePollBorderRadiusChange", (borderRadius) => this.updateDesign({
      poll: __spreadProps(__spreadValues({}, this.props.componentData.design.poll), { borderRadius })
    }));
    __publicField(this, "handleOptionBorderRadiusChange", (borderRadius) => this.updateDesign({
      options: __spreadProps(__spreadValues({}, this.props.componentData.design.options), {
        borderRadius
      })
    }));
    __publicField(this, "handleTypeChange", (backgroundType) => {
      this.setState(
        { backgroundType },
        () => this.handleBackgroundChange(BACKGROUND_PRESETS[backgroundType][0])
      );
    });
    __publicField(this, "dataMapper", ({ name }) => {
      return { value: name };
    });
    __publicField(this, "renderOption", ({ item, selected }) => /* @__PURE__ */ React.createElement(SelectionListItem, { icon: /* @__PURE__ */ React.createElement(item.icon, null), label: item.label, selected }));
  }
  updateDesign(design) {
    const { updateData, componentData } = this.props;
    updateData({ design: __spreadValues(__spreadValues({}, componentData.design), design) });
  }
  getBackgroundColorValue() {
    var _a2;
    const { componentData } = this.props;
    const { backgroundType } = this.state;
    const { design } = componentData;
    return toBackgroundString((_a2 = design.poll) == null ? void 0 : _a2.background, backgroundType, 48, 48);
  }
  getColorPalettePreset() {
    const { backgroundType } = this.state;
    const { design } = this.props.componentData;
    let calcBgValue = (value) => ({ color: value });
    const preset = BACKGROUND_PRESETS[backgroundType];
    if (backgroundType === BACKGROUND_TYPES.GRADIENT) {
      calcBgValue = (value) => ({ gradient: JSON.parse(value) });
    }
    if (backgroundType === BACKGROUND_TYPES.IMAGE) {
      calcBgValue = (value) => ({ image: { src: { url: value } } });
    }
    return preset.map((value) => {
      var _a2, _b2;
      return toBackgroundString(
        __spreadValues(__spreadValues({}, (_a2 = design.poll) == null ? void 0 : _a2.background), calcBgValue(value)),
        (_b2 = design.poll) == null ? void 0 : _b2.background.type,
        48,
        48
      );
    });
  }
  render() {
    var _a2, _b2;
    const { t, componentData, languageDir } = this.props;
    const { backgroundType } = this.state;
    const { design } = componentData;
    return /* @__PURE__ */ React.createElement("section", { className: styles.section }, /* @__PURE__ */ React.createElement("p", { className: styles.title }, t("Poll_PollSettings_Tab_Design_Section_Background_Header")), /* @__PURE__ */ React.createElement("p", { className: styles.subtitle }, t("Poll_PollSettings_Tab_Design_Section_Background_Choose")), /* @__PURE__ */ React.createElement(
      SelectionList,
      {
        dataSource: [
          {
            dataHook: POLLS_DESIGN_BACKGROUND.COLOR,
            name: BACKGROUND_TYPES.COLOR,
            label: t("Poll_PollSettings_Tab_Design_Section_Background_Color"),
            icon: ColorIcon
          },
          {
            dataHook: POLLS_DESIGN_BACKGROUND.GRADIENT,
            name: BACKGROUND_TYPES.GRADIENT,
            label: t("Poll_PollSettings_Tab_Design_Section_Background_Gradient"),
            icon: GradientIcon
          },
          {
            dataHook: POLLS_DESIGN_BACKGROUND.IMAGE,
            name: BACKGROUND_TYPES.IMAGE,
            label: t("Poll_PollSettings_Tab_Design_Section_Background_Pattern"),
            icon: ImageIcon
          }
        ],
        dataMapper: this.dataMapper,
        renderItem: this.renderOption,
        onChange: this.handleTypeChange,
        value: backgroundType,
        className: styles.layout_selector
      }
    ), /* @__PURE__ */ React.createElement("p", { className: styles.title }, t(_DesignSettingsSection.PICK_BACKGROUND_LABELS[backgroundType])), /* @__PURE__ */ React.createElement(
      ColorPicker,
      {
        color: this.getBackgroundColorValue(),
        palette: this.getColorPalettePreset(),
        schemeAttributes: BACKGROUND_PRESETS[backgroundType],
        onChange: this.handleBackgroundColorChange,
        t
      },
      ({ renderPalette }) => /* @__PURE__ */ React.createElement("div", { className: styles.colorPicker_palette }, renderPalette())
    ), /* @__PURE__ */ React.createElement(SettingsSeparator, { top: true, bottom: true }), /* @__PURE__ */ React.createElement("p", { className: styles.title }, t("Poll_PollSettings_Tab_Design_Section_CornerRadius_Header")), /* @__PURE__ */ React.createElement(
      SliderWithInput,
      {
        min: 0,
        max: 20,
        label: t("Poll_PollSettings_Tab_Design_Section_CornerRadius_Poll"),
        onChange: this.handlePollBorderRadiusChange,
        defaultValue: parseInt((_a2 = design.poll) == null ? void 0 : _a2.borderRadius),
        languageDir
      }
    ), /* @__PURE__ */ React.createElement("div", { className: styles.pollsSettings_spacer }), /* @__PURE__ */ React.createElement(
      SliderWithInput,
      {
        min: 0,
        max: 10,
        label: t("Poll_PollSettings_Tab_Design_Section_CornerRadius_Answers"),
        onChange: this.handleOptionBorderRadiusChange,
        defaultValue: parseInt((_b2 = design.options) == null ? void 0 : _b2.borderRadius),
        languageDir
      }
    ));
  }
};
let DesignSettingsSection = _DesignSettingsSection;
__publicField(DesignSettingsSection, "PICK_BACKGROUND_LABELS", {
  [BACKGROUND_TYPES.COLOR]: "Poll_PollSettings_Tab_Design_Section_Background_Color_Pick",
  [BACKGROUND_TYPES.IMAGE]: "Poll_PollSettings_Tab_Design_Section_Background_Pattern_Pick",
  [BACKGROUND_TYPES.GRADIENT]: "Poll_PollSettings_Tab_Design_Section_Background_Gradient_Pick"
});
DesignSettingsSection.propTypes = {
  t: PropTypes.func.isRequired,
  componentData: PropTypes.object.isRequired,
  experiments: PropTypes.object,
  updateData: PropTypes.func.isRequired,
  languageDir: PropTypes.string.isRequired
};

export { DesignSettingsSection };
//# sourceMappingURL=DesignSettingsSection.js.map
